export function openPdfDocument(doc, filename = "document.pdf") {
  const pdfUrl = doc.output("bloburl");
  const openedWindow = window.open(pdfUrl, "_blank");

  if (!openedWindow) {
    doc.save(filename);
  }
}
